import { CreateLabelText } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/AbstractScrollableContentView";
import { BetData } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/paytable/PaytableContent";
import { BasePaytableComponent } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/paytable/components/BasePaytableComponent";
import { SimpleTextPaytableComponentComponentPayload } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/paytable/components/SimpleTextPaytableComponent";
import { TextFromContainer } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/utils";
import { GameServices } from "game/GameServices";
import { Text } from "pixi.js";

export class DynamicPayoutComponent extends BasePaytableComponent {
    private readonly textfield: Text;
    private readonly text: string;

    constructor(protected override services: GameServices, payload: SimpleTextPaytableComponentComponentPayload, createLabelText: CreateLabelText, name?: string) {
        super(services);
        this.text = payload.title.label;
        this.textfield = this.addChild(createLabelText(payload.title, 0.5, 0));
        if (name) {
            this.name = name;
        }
    }

    onOpen(betData: BetData) {
        this.textfield.text = this.text.replace(/{[\d|.]+}/g, num => this.services.currency.formatCoinsUI(parseFloat(num.replace(/[\{\}']+/g, ``)) * betData.totalBet, { useSubUnits: true, group: true, trimIntegers: false }));
    }
    updateLayout() { }

    /**
     * Return Pixi container as HTML friendly Text content.
     * Used for search functionality
     */
    getRenderedContentAsText(): Promise<ReadonlyArray<TextFromContainer>> {
        return Promise.resolve([{ title: ``, content: this.textfield.text }]);
    }
}
